import * as React from 'react';
import { Button } from 'antd';

import '../../../../i18n';
import { useTranslation } from 'react-i18next';

export const RingTwoInfo = () => {

    const { t } = useTranslation('orbitario');

    return (
        <div className="work-flow-main-info">
                <h1>{t("servers.title")}</h1>
                <h3>{t("servers.subTitle")}</h3>
                <p>
                    {t("servers.text")}
                </p>
            </div>
    );
}